const qr = {
  coffin: {
    occupied: {
      coffin: 'El QR de feretre que intenta afegir ja s\'està utilitzant com a Qr de fèretre en aquest o altre expedient',
      deceased: 'El QR de feretre que intenta afegir ja s\'està utilitzant com a Qr de difunt en aquest o altre expedient',
      personalitems: 'El QR de feretre que intenta afegir ja s\'està utilitzant com a Qr d\'objectes personals en aquest o altre expedient',
      urn: 'El QR de feretre que intenta afegir ja s\'està utilitzant com a Qr d\'urna en aquest o altre expedient',
    },
  },
  coffinQr: 'QR Taüt',
  deceased: {
    occupied: {
      coffin: 'El QR de difunt que intenta afegir ja s\'està utilitzant com a Qr de fèretre en aquest o altre expedient',
      deceased: 'El QR de difunt que intenta afegir ja s\'està utilitzant com a Qr de difunt en aquest o altre expedient',
      personalitems: 'El QR de difunt que intenta afegir ja s\'està utilitzant com a Qr d\'objectes personals en aquest o altre expedient',
      urn: 'El QR de difunt que intenta afegir ja s\'està utilitzant com a Qr d\'urna en aquest o altre expedient',
    },
  },
  occupied: {
    coffin: 'El QR de feretre ja s\'ha utilitzat en aquest expedient o en un altre',
    deceased: 'El QR de polsera ja s\'ha fet servir en aquest o altre expedient.',
    personalitems: 'El QR d\'objectes personals ja s\'ha utilitzat en aquest expedient o en un altre',
    urn: 'El QR d\'urna ja s\'ha utilitzat en aquest expedient o en un altre.',
  },
  personalitems: {
    occupied: {
      coffin: 'El QR d\'objectes personals que intenta afegir ja s\'està utilitzant com a Qr de fèretre en aquest o altre expedient',
      deceased: 'El QR d\'objectes personals que intenta afegir ja s\'està utilitzant com a Qr de difunt en aquest o altre expedient',
      personalitems: 'El QR d\'objectes personals que intenteu afegir ja s\'està utilitzant com a Qr d\'objectes personals en aquest o altre expedient',
      urn: 'El QR d\'objectes personals que intenteu afegir ja s\'està utilitzant com a Qr d\'urna en aquest o altre expedient',
    },
  },
  personalItemsQr: 'QR Objectes personals',
  qr: 'QR Polsera',
  search: 'Cercar consultes',
  title: 'Consultes',
  urn: {
    occupied: {
      coffin: 'El QR d\'urna que intenta afegir ja s\'està utilitzant com a Qr de fèretre en aquest o altre expedient',
      deceased: 'El QR d\'urna que intenta afegir ja s\'està utilitzant com a Qr de difunt en aquest o altre expedient',
      personalitems: 'El QR d\'urna que intenteu afegir ja s\'està utilitzant com a Qr d\'objectes personals en aquest o altre expedient',
      urn: 'El QR d\'urna que intenta afegir ja s\'està utilitzant com a Qr d\'urna en aquest o altre expedient',
    },
  },
  urnQr: 'QR Urna',
};

export default qr;
